module.exports = {
      id: "newslettericon-usage",
      viewBox: "0 0 48 47.861",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#newslettericon",
      toString: function () {
        return this.url;
      }
    }